/*
 *
 *  * Copyright(c) 2022 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */
import * as _ from 'underscore';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'uniqueValues'
})
export class UniqueValuesPipe implements PipeTransform {
  transform(items: any[], fieldName: string = undefined, isArray = false): any[] {
    if (!items || (items && !items.length)) {
      return [];
    }

    if (!!fieldName) {
      return isArray
        ? [...new Set(_.flatten(items.map(item => item[fieldName])))]
        : [...new Set(items.map(item => item[fieldName]))];
    } else {
      return [...new Set(items)];
    }
  }
}
